import { useEffect, useState } from "react";

export const LAUNCH_AT = new Date("2026-11-04T14:00:00Z");

const parts = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [["Days", Math.floor(s / 86400)], ["Hrs", Math.floor((s % 86400) / 3600)], ["Min", Math.floor((s % 3600) / 60)], ["Sec", s % 60]];
};

export const Countdown = ({ prefix = "hero" }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const left = LAUNCH_AT.getTime() - now;
  if (left <= 0) {
    return <p className="text-sm font-semibold text-[#9E4429]" data-testid={`${prefix}-countdown-live`}>Lunelle is live. Download it today.</p>;
  }
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`${prefix}-countdown`}>
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#7A665C]">Launching Nov 4</span>
      <div className="flex gap-1.5">
        {parts(left).map(([label, v]) => (
          <span key={label} className="flex min-w-[52px] flex-col items-center rounded-xl border border-[#C86D51]/20 bg-white/60 px-2 py-1.5 backdrop-blur-md">
            <span className="font-serif text-2xl leading-none tabular-nums text-[#2C221E]" data-testid={`${prefix}-countdown-${label.toLowerCase()}`}>{String(v).padStart(2, "0")}</span>
            <span className="mt-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#7A665C]">{label}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
